import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types';
import { Button, Card, Col, Container, Form, Jumbotron, Row } from 'react-bootstrap';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import { useSelector } from 'react-redux';
import { useisLoading } from '../../hook/useisLoading';
import Loading from '../../components/common/Loading';
import InputField from '../../components/common/InputField';
import Checkbox from '../../components/common/Checkbox';
import { useForm } from 'react-hook-form';
import PageHeaderStandar from '../../components/common/PageHeaderStandar';
import { ButtonBack } from '../../components/common/ButtonBack';
import ErrorMessage from '../../components/common/ErrorMessage';
import { helperConfirmationAlert } from '../../components/helpers/helperConfirmationAlert';
import { Redirect } from 'react-router-dom';
import { set } from 'react-global-configuration';
import { ButtonEdit } from '../../components/common/ButtonEdit';
import SelectCombobox from '../../components/common/SelectCombobox';
import { BillingAPI, Plan } from '../../components/apis/billing';
import { useColumns } from '../../hook/useColumns';
import types from '../../types/types';
import { regexStandardName } from '../../components/common/Util';
import { message } from '../../components/common/Notification';
import ButtonsSaveAndCancel from '../../components/common/ButtonsSaveAndCancel';
import ReactTable from '../../components/helpers/ReactTable';
import { useTable } from 'react-table';
import { ButtonGeneric } from '../../components/common/ButtonGeneric';

export const PlanEdition = (props, context) => {

    console.log("Enter into PlanEdition.js");

    // We check if Component is called form path '/planEdition/new' or path '/planEdition/view/:id' to define if user is trying to create a new plan or editing it.
    const isNewPlan = (props.id === undefined)?true:false;

    // Variable to show/hide "spinner" while loading page.
    const { isLoading, showSpinner, hideSpinner } = useisLoading(true);
    const { isLoading: isLoadingAccordionElement, showSpinner: showAccordionElement, hideSpinner: hideAccordionElement } = useisLoading(true);

    // Get user and token from Redux
    const { user, token } = useSelector(state => state.user);
    
    const [apiBilling, setApiBilling] = useState(null);

    const {getColumnsConfigurationElements, getColumnsConfigurationElementsInPlan } = useColumns(context);

    const [headerDataConfigurationElementsInPlan, setHeaderDataConfigurationElementsInPlan] = useState(useMemo(() => getColumnsConfigurationElementsInPlan(), []))
    const [rowsDataConfigurationElementsInPlan, setRowsDataConfigurationElementsInPlan] = useState([]);
    
    const [headerDataConfigurationElements, setHeaderDataConfigurationElements] = useState(useMemo(() => getColumnsConfigurationElements(), []))
    const [rowsDataConfigurationElements, setRowsDataConfigurationElements] = useState([]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ 
        columns: headerDataConfigurationElements,
        data: rowsDataConfigurationElements,
    });
    
    // Stander useForm of react-hook-form Library
    const { register, handleSubmit, getValues, setValue, formState: { errors } } = useForm({
        defaultValues: {
            
            business_description: "",
            business_name: "",
            // setValue("created_at", plan.created_at);
            // setValue("deleted_at", plan.deleted_at);
            // setValue("elements", plan.elements);
            enabled: true,
            // setValue("id", plan.id);
            // setValue("plan_id", plan.plan_id);
            snx_description: "",
            snx_name: "",
            id_elements: -1,

            // backendError is used to set back-end-error message when service has fail (to show to the user)
            backendError: null,
            // onSubmitOk is used to control if onSubmit acction was success.
            onSubmitOk: null,         
        }
    });

    // Load API Object
    useEffect(() => {

        if (token) {
            setApiBilling(new BillingAPI(token));
        }

    }, [token])

    // Use effect to load configuration elements data from managment API.
    useEffect( () => {
        if (apiBilling){
                        
            apiBilling.getConfigurationElements().then(  (elements) => {
                
                setRowsDataConfigurationElements(elements)     

            }).catch(err => {
                console.log("Error getting all configuration elements data from Management.js: " + err)
                setValue(types.ERROR,  context.t("There was a problem on our end. Please try again later."));

            });
        }

    }, [apiBilling]);

    
    useEffect(() => {

        if(apiBilling){
            if (isNewPlan){

                // If user is not a ROOT, we force account id selection.
                if (user.roles[0].id !== types.USER_ROOT_ID){
                    //TODO: handle when user is not ROOT. What should we do if user is a customer admin?
                    // setValue("account_id", user.accounts[0].id);
                }

                // Stop spinnner and render page.
                hideSpinner();
            } else{ // We are "editing" a user.
            
                // const userValues = await getUserById(props.id);
                apiBilling.getCommercialPlanById(props.id).then(  (plan) => {
                    
                    setValue("business_description", plan.business_description);
                    setValue("business_name", plan.business_name);
                    setValue("created_at", plan.created_at);
                    setValue("deleted_at", plan.deleted_at);
                    setRowsDataConfigurationElementsInPlan(plan.elements);
                        
                    // Array to fill with element configurated into the commercila plan selected or to be created.
                    var elementsInPlan = [];
                    // Fill "elements id" into an Array in order to filter before the configuration elements without these elements.
                    plan.elements.forEach(element => {
                        elementsInPlan.push(element.element_id);
                    });
                    
                    setValue("elementsInPlan", elementsInPlan);
                    showAccordionElement();
                    
                    setValue("elements", plan.elements);
                    setValue("enabled", plan.enabled);
                    setValue("id", plan.id);
                    setValue("plan_id", plan.plan_id);
                    setValue("snx_description", plan.snx_description);
                    setValue("snx_name", plan.snx_name);

                    console.log("elementsInPlan: " + elementsInPlan)

                }).catch(err => {
                    console.log("Error getting standar commercial plan data from PlanEdition.js: " + err)
                    setValue(types.ERROR,  context.t("There was a problem on our end. Please try again later."));

                });    
            }
        
        }
    }, [apiBilling]);


    // Load all Configuration Elements
    useEffect(() => {

        if (apiBilling) {
            apiBilling.getConfigurationElements().then(  (elements) => {
                // TODO: Get element by type to fill comboxes or user options

            }).catch(err => {
                console.log("Error getting configuration elements from PlanEdition.js: " + err)
                setValue(types.ERROR,  context.t("There was a problem on our end. Please try again later."));
            }).finally(()=>{
                // Show page after load information
                hideSpinner();
            });
        }

    }, [apiBilling])


    // Function calls at form submit
    const onSubmit = data => {
        
        // Show spinner
        showSpinner();
        if (isNewPlan){
            
            // Create "new plan objet"
            const newPlan = new Plan({
                // TODO: Creat new Commercial Plan Object
            });
                            
            // Call function to create "new" plan
            apiBilling.createPlan(newPlan, context).then(() => {
                
                // Set onSubmitOk in "true" in order to redirect to the user list after crete the new user.
                setValue("onSubmitOk",  true );

                // Stop spinnner and render page.
                hideSpinner();
                
                message(context.t("Plan creation"), context.t("Plan created successfully"));
            
            }).catch(err => {
                console.log("NewPlan onSubmit error: " + err);
                // Set "backendError" show a back-end error as message to the user at the top.
                setValue("backendError", context.t(err.message));
                
            }).finally( () =>{
                // Stop spinnner and render page.
                hideSpinner();
            });

        } else { // It's a plan edition.

            // Show spinner
            showSpinner();
            
            console.log("getValues().id: " + getValues().id);
            debugger
            // Create "new plan objet"
            const planToModify = new Plan({
                // "id": getValues().id,
                // "account_id" : parseInt(getValues().account_id),
                // "given_name" : getValues().given_name,
                // "family_name" : getValues().family_name,
                // "verified_email": getValues().verified_email,
                // "user_name" : getValues().user_name,
                // "phone_number" : getValues().phone_number,
                // "avatar_picture" : getValues().avatar_picture,
                // "enabled" : true, 
                // "rol_id" : parseInt(getValues().role_id), 
            });
            
            // Call function to modify "new" plan
            apiBilling.update(planToModify).then(() => {        
                // Set onSubmitOk in "true" in order to redirect to the user list after update the user values.
                setValue("onSubmitOk",  true );
                message(context.t("Plan update"), context.t("Update done successfully"));

            }).catch(err => {
                console.log("PlanEdition onSubmit error: " + err);
                // Set "backendError" show a back-end error as message to the user at the top.
                setValue("backendError",  context.t(err.message) );
            
            }).finally( () =>{
                // Stop spinnner and render page.
                hideSpinner();
            });
        } // End Else
    };
        
    // If OnSubmit was success, redirect to management page
    if (getValues().onSubmitOk){
        return <Redirect to='/management' />
    }

    if (isLoading) {
        return <Loading/>
    } else {
        return (
            <Container fluid>
                {/* If "backendError" has value, it shows to the user */}
                <ErrorMessage message={getValues().backendError}/>

                {/* Page header has Title and Subtite of the page */}
                <PageHeaderStandar title={context.t('Commercial Plan')} subtitle={ (isNewPlan)?context.t('Add'):context.t('Edit') } />

                <Card small="true" style={{ marginBottom: '20px'}}>
                    <Form validate="true" onSubmit={ handleSubmit(onSubmit) } style={{ padding: "10px"}}>
                    <input type={'hidden'} {...register("id")} />
                    <Row>
                        <Col lg="6">
                            <InputField type="text"
                                label= { context.t('Commercial Name') }
                                name="business_name"
                                placeholder={ context.t('Commercial Name') }
                                errors={errors} 
                                useFormRegister= {
                                register("business_name", { 
                                    required: context.t("This is required"), 
                                    pattern: {
                                    value: regexStandardName(),
                                    message: context.t("Value entered is not allowed"),
                                    }
                                })
                                }
                            />

                            <InputField label={context.t('Plan Description')} name="business_description" placeholder={context.t('Plan Description')} 
                                errors={errors} 
                                useFormRegister= {
                                register("business_description", { 
                                    required: context.t("This is required"), 
                                    pattern: {
                                    value: regexStandardName(),
                                    message: context.t("Value entered is not allowed"),
                                    }
                                })
                                }
                            />


                            {
                                (isNewPlan)?(
                                    <>
                                        <InputField label={context.t('Password')} type="password" name="password" placeholder={context.t('********')} 
                                            errors={errors} 
                                            useFormRegister= {
                                            register("password", { 
                                                required: context.t("This is required"),
                                                pattern: {
                                                // value: regexPassword(), // eslint-disable-line 
                                                message: context.t("Password must be between 8 and 30 characters, at least one uppercase, one lowercase and one special character"),
                                                }
                                            })
                                            }
                                        />

                                        <InputField label={context.t('Confirm Password')} type="password" name="confirm_password" placeholder={context.t('********')} 
                                            errors={errors} 
                                            useFormRegister= {
                                            register("confirm_password", { 
                                                required: context.t("This is required"), 
                                                validate: {
                                                identicalPasswords: value => (value === getValues().password) || context.t("Passwords must be the same"), 
                                                },
                                            })
                                            }
                                        />
                                    </>
                                ):(null)
                            }

                            <Checkbox label={context.t('Enabled')} disabled={true} name="enabled" useFormRegister= {register("enabled", {})}  />

                        </Col>
                        <Col lg="6">
                            <InputField type="text"
                                label= { context.t('Internal Name') }
                                name="snx_name"
                                placeholder={ context.t('Internal Name') }
                                errors={errors} 
                                useFormRegister= {
                                register("snx_name", { 
                                    required: context.t("This is required"), 
                                    pattern: {
                                    value: regexStandardName(),
                                    message: context.t("Value entered is not allowed"),
                                    }
                                })
                                }
                            />

                            <InputField label={context.t('Internal Description')} name="snx_description" placeholder={context.t('Doe')} 
                                errors={errors} 
                                useFormRegister= {
                                register("snx_description", { 
                                    required: context.t("This is required"), 
                                    pattern: {
                                    value: regexStandardName(),
                                    message: context.t("Value entered is not allowed"),
                                    }
                                })
                                }
                            />

                            {
                                // (getValues().elements).forEach(el => {
                                //     return <h1>{el.id + " - " +el.name}</h1>
                                    
                                // })
                                (isNewPlan && user.roles[0].id === types.USER_ROOT_ID)?( // Only ROOT user must select Elements for a new plan.
                                    null
                                ):(
                                    null
                                )
                            }       
                        </Col>
                    </Row>
                    <Row>                        
                        <Col lg="12">
                            <Form.Label>Plan Elements</Form.Label>
                            <ReactTable headerData={headerDataConfigurationElementsInPlan} rowsData={rowsDataConfigurationElementsInPlan} actionURI={"/configurationElementsInPlan/remove/"} idReference={"id"} buttonIcon={"delete"}/>                      
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12">
                            <Accordion allowZeroExpanded preExpanded={['a']}>
                                <AccordionItem uuid="a">
                                    <AccordionItemHeading onClick={ () => {return true} } >
                                                <AccordionItemButton >
                                                    Selectable configuration elements
                                                </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel > 
                                        {(isLoadingAccordionElement)?(
                                            <div>
                                                
                                                <table className="table table-sm scrollable-div">
                                                    <thead>
                                                        {headerGroups.map((headerGroup) => (
                                                        <tr {...headerGroup.getHeaderGroupProps()}>
                                                            {headerGroup.headers.map((column) => (
                                                            <th {...column.getHeaderProps()} scope="col">
                                                                {column.render("Header")}
                                                            </th>
                                                            ))}
                                                        </tr>
                                                        ))}
                                                    </thead>
                                                    <tbody {...getTableBodyProps()}>
                                                        {rows.map((row) => {
                                                        prepareRow(row);

                                                        console.log(row.original.id)
                                                        console.log(getValues().elementsInPlan)
                                                        return (
                                                            (getValues().elementsInPlan != null && (getValues().elementsInPlan).indexOf(row.original.id) !== -1)?
                                                                null //The element already exists in this plan, so we remove it from list of configuration elements
                                                            :                                                       
                                                            (
                                                                <tr {...row.getRowProps()}>
                                                                    {row.cells.map((cell) => {
                                                                        return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                                                                    })}
                                                                    <td>
                                                                        <ButtonGeneric icon={"remove_red_eye"} to={"viewElement/"+ row.original.id }/>
                                                                    </td>
                                                                    <td>
                                                                        <ButtonGeneric icon={"control_point"} to={"addElement/"+ row.original.id }/>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ):(null)}
                                    </AccordionItemPanel>
                                </AccordionItem>
                            </Accordion>
                        </Col>
                    </Row>
                    <hr/>
                    <ButtonsSaveAndCancel/>
                    </Form>
                </Card>
            </Container>
        )
    }
}

PlanEdition.contextTypes = {
    t: PropTypes.func.isRequired
}

export default PlanEdition